/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/* eslint-disable sonarjs/no-hardcoded-passwords -- route names are constants, not secrets */

/**
 * URL path constants for every route in the application.
 * Used by AppRoutes, navigation hooks, and route guards.
 */
export const LocationUrls = {
  SPLASH: "/",
  SIGN_IN: "/signin",
  FORGOT_PASSWORD: "/forgot-password",
  REQUEST_NEW_LINK: "/request-new-link",
  PASSWORD_HTML: "/password.html",
  PLAYER: "/player",
  HOME_SCREEN: "/home",
  GUIDE: "/guide",
  SELECT_PROFILE: "/select-profile",
  PROFILES: "/profiles",
  PROFILE_DETAILS: "/profile-details",
  CONTENT_DETAIL: "/content-detail",
  MY_HUB: "/my-hub",
  MY_HUB_MANAGE_SCREEN: "/my-hub/manage-recordings",
  MY_HUB_SCHEDULED_SERIES: "/my-hub/scheduled-series",
  MY_HUB_SCHEDULED_SINGLE: "/my-hub/scheduled-single",
  SPORTS_HUB: "/sports",
  SHOWS_AND_MOVIES: "/shows-movies",
  SEARCH: "/search",
  SEE_MORE: "/see-more",
  SETTINGS: "/settings"
} as const;
